import {
  ScheduleChannel,
  ScheduleChannelType
} from '@dadohr/shared/domainTypes/schedules';
import { assertNever } from 'assert-never';
import { UnsafeTFunction } from '../../i18next';

export const EMAIL_FIELDS = ['personalEmail', 'email'];

export const channelMarkerToString = (
  emailFrom: 'email' | 'personalEmail' | string,
  t: UnsafeTFunction
) => {
  return emailFrom === 'email'
    ? t('Work Email')
    : emailFrom === 'personalEmail'
    ? t('Personal Email')
    : '';
};

export const channelToString = (d: ScheduleChannel, t: UnsafeTFunction) => {
  if (d.type === ScheduleChannelType.EMAIL) {
    return channelMarkerToString(d.emailFrom, t);
  }
  if (d.type === ScheduleChannelType.SLACK) {
    return 'Slack';
  }

  if (d.type === ScheduleChannelType.MS_TEAMS) {
    return 'Microsoft Teams';
  }
  if (d.type === ScheduleChannelType.SMS) {
    return 'SMS';
  }
  console.warn('COULD NOT RENDER CHANNEL TO STRING', d);
  return null;
};

export const channelToKey = (s: ScheduleChannel) => {
  switch (s.type) {
    case ScheduleChannelType.EMAIL:
      return `${s.type}-${s.emailFrom}`;
    case ScheduleChannelType.SLACK:
      return `${s.type}-dm`;
    case ScheduleChannelType.MS_TEAMS:
      // TODO
      return `${s.type}`;
    case ScheduleChannelType.SMS:
      return `SMS`;
    case ScheduleChannelType.NONE:
      return `${s.type}`;
    default:
      return assertNever(s);
  }
};
